import { render, staticRenderFns } from "./chapterView.vue?vue&type=template&id=7ba0ed1d"
import script from "./chapterView.vue?vue&type=script&lang=js"
export * from "./chapterView.vue?vue&type=script&lang=js"
import style0 from "./chapterView.vue?vue&type=style&index=0&id=7ba0ed1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports